export default __webpack_public_path__ + "static/media/tower-right.7a228bdd.svg";